import React from 'react';
import { Box, ToggleButtonGroup, ToggleButton } from '@mui/material';
import { styled } from '@mui/material/styles';
import { useNavigate, useLocation } from 'react-router-dom';
import quicksightConfig from '@/config/quicksight.config';
import DailyWeeklyToggle from './DailyWeeklyToggle';

const StyledToggleButtonGroup = styled(ToggleButtonGroup)({
  backgroundColor: 'transparent',
  border: '1px solid rgb(207, 207, 207)',
  borderRadius: '5px',
  '& .MuiToggleButtonGroup-grouped': {
    margin: 0,
    borderRadius: 0,
    borderLeft: '1px solid rgb(207, 207, 207)',
    '&:first-of-type': {
      borderLeft: 'none',
      borderTopLeftRadius: '5px',
      borderBottomLeftRadius: '5px',
    },
    '&:last-of-type': {
      borderTopRightRadius: '5px',
      borderBottomRightRadius: '5px',
    },
  },
});

const StyledToggleButton = styled(ToggleButton)({
  width: 95,
  height: 38,
  fontSize: '12px',
  fontWeight: 400,
  textTransform: 'none',
  color: 'rgb(30, 30, 30)',
  backgroundColor: '#ffffff',
  border: 'none',
  padding: '4px 8px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: '1px',
  whiteSpace: 'normal',
  lineHeight: 1.1,
  '&.Mui-selected': {
    backgroundColor: '#FFBC0D',
    color: '#000',
    fontWeight: 700,
  },
});

const DASHBOARD_TABS = [
  { key: 'digital', label: ['Digital', 'Performance'], id: quicksightConfig.dashboards.digital },
  { key: 'offer', label: ['Offer', 'Performance'], id: quicksightConfig.dashboards.offer },
  { key: 'store', label: ['Store', 'Performance'], id: quicksightConfig.dashboards.store },
];

const DashboardTabs: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const currentDashboardId = location.pathname.substring(1) || quicksightConfig.defaultDashboardId;

  const handleChange = (_event: React.MouseEvent<HTMLElement>, targetId: string | null) => {
    if (targetId !== null) {
      navigate(`/${targetId}`);
    }
  };

  const isTabSelected = (tabId: string): boolean => {
    if (currentDashboardId === tabId) return true;
    
    if (tabId === quicksightConfig.dashboards.digital && currentDashboardId === quicksightConfig.dashboards.dwd) {
      return true;
    }
    if (tabId === quicksightConfig.dashboards.offer && currentDashboardId === quicksightConfig.dashboards.dwdOffer) {
      return true;
    }
    
    return false;
  };

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
      <StyledToggleButtonGroup
        value={currentDashboardId}
        exclusive
        onChange={handleChange}
        aria-label="dashboard selection"
      >
        {DASHBOARD_TABS.map(({ key, label, id }) => (
          <StyledToggleButton 
            key={key} 
            value={id} 
            aria-label={label.join(' ')}
            selected={isTabSelected(id)}
          >
            {label.map((line, index) => (
              <span key={index}>{line}</span>
            ))}
          </StyledToggleButton>
        ))}
      </StyledToggleButtonGroup>

      <DailyWeeklyToggle />
    </Box>
  );
};

export default DashboardTabs;
